import { resolveInitialSwatchId } from '~/shared/resolveInitialSwatchId'

export const getInitialColorSwatchId = (
  tileEntity: State.TileEntity,
  selectedDesignId: Gallery.Models.Url.ValidParsedQsValue<string>,
  designById: (id: string) => State.Design,
): string => {
  if (selectedDesignId && designById(selectedDesignId)) {
    return selectedDesignId
  }

  const currentDesignId =
    typeof window !== 'undefined' && (window.history.state?.usr?.designId ?? window.history.state?.designId)
      ? (window.history.state.designId ?? window.history.state.usr.designId)
      : resolveInitialSwatchId(tileEntity)

  return currentDesignId
}

export const normalizeQuickViewUrl = (url: string, searchParam: string): string => {
  const urlObj = new URL(url)

  urlObj.searchParams.delete(searchParam)

  return urlObj.toString()
}
